<template>
  <div>
    <b-row>
      <b-col cols="12" xl="8">
        <div class="form-container separator">

          <pcg-text-input class="abk-input col-12"
                          :required="true"
                          :label="$t('views.dictionaries.labels.name')"
                          :error-text="getError('name')"
                          :show-error="errorExist('name')"
                          v-model="dictionary.name"/>

          <pcg-text-input class="abk-input col-12" type="textarea"
                          :label="$t('views.dictionaries.labels.description')"
                          :error-text="getError('description')"
                          :show-error="errorExist('description')"
                          v-model="dictionary.description"/>
          <pcg-checkbox class="col-12"
                        :error-text="getError('dictionary_type')"
                        :show-error="errorExist('dictionary_type')"
                        v-model="dictionary.dictionaryTypeBoolean">
            {{$t('views.dictionaries.edit.dictionary_type')}}
          </pcg-checkbox>
          <pcg-btn v-if="dictionary"
                   size="small"
                   variant="additional"
                   class="action-btn"
                   @click="updateDictionary(true)">
            {{ $t('views.common.save') }}
          </pcg-btn>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import ApiDictionaries from '../../api/dictionaries'
export default {
  name: 'DictionariesEdit',
  data () {
    return {
      id: this.$route.params.id,
      errors: {},
      dictionary: {
        name: null,
        description: null,
        dictionaryTypeBoolean: null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  },
  mounted () {
    this.getDictionary()
  },
  methods: {
    getDictionary () {
      ApiDictionaries.getDictionary(this.id)
        .then(response => {
          this.dictionary = response.data.data.attributes
          if (this.dictionary.dictionaryType === 'open') {
            this.dictionary.dictionaryTypeBoolean = true
          } else {
            this.dictionary.dictionaryTypeBoolean = false
          }
          this.$store.dispatch('header/setObjectName', this.dictionary.name)
        }).catch(error => {
          this.$toastr.e(error)
          console.log(error)
        })
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.dictionaries.edit.title'),
        subtitle: this.$t('views.dictionaries.edit.subtitle')
      })
    },
    updateDictionary () {
      this.loading = true
      const dictionaryDup = this.dictionary
      if (this.dictionary.dictionaryTypeBoolean) {
        dictionaryDup.dictionaryType = 'open'
      } else {
        dictionaryDup.dictionaryType = 'closed'
      }
      ApiDictionaries.updateDictionary(this.id, { dictionary: dictionaryDup })
        .then(() => {
          this.errors = {}
          this.getDictionary()
          setTimeout(() => { this.$toastr.s(this.$t('general.dictionary_updated')) }, 1)
          this.$router.go(-1)
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
        })
    },
    getError (field) {
      if (this.errorExist(field)) {
        return this.errors[field].join(', ')
      }
      return ''
    },
    errorExist (field) {
      return !!(this.errors && this.errors[field])
    }
  }
}
</script>
